<template>
  <div
    ref="medium-priority-alert-wrapper"
    class="medium-priority-alert-wrapper"
  >
    <div
      v-focus-trap
      class="medium-priority-alert-container"
      :class="{
        'medium-priority-alert-container-compact': isMobileScreenOrCompactWidget
      }"
    >
      <div
        class="alert-content"
        :style="{ ...getFontSizeForChatInterface('bodyText') }"
      >
        <div class="alert-header">
          <BaseIcon
            name="WarningIcon"
            width="24px"
            height="24px"
            fill="#F06C00"
          />
          <p
            class="header-text"
            :style="{ ...getFontSizeForChatInterface('title') }"
          >
            {{ getAlertTitle }}
          </p>
        </div>
        <div class="details" v-html="sanitizeFontStyles(getAlertDetails)" />
        <div
          v-if="isAlertButtonEnabled && getAlertButtonLabel?.length"
          role="button"
          tabindex="0"
          class="card-button"
          @click.stop="handleAlertButtonClicked"
          @keydown.enter.stop="handleAlertButtonClicked"
        >
          {{ getAlertButtonLabel }}
        </div>
        <div
          role="button"
          tabindex="0"
          class="close-btn"
          @click.stop="handleCloseClicked"
          @keydown.enter.stop="handleCloseClicked"
        >
          Close
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/views/BaseIcon.vue'
import { getDeviceType } from '@/services/utils'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  components: {
    BaseIcon
  },
  mixins: [fontSizeMixin],
  data() {
    return {
      setTimeoutTimerId: ''
    }
  },
  computed: {
    isMobileScreenOrCompactWidget() {
      return (
        getDeviceType() === 'mobile' ||
        !this.$store.state.isChatWidgetFullScreen
      )
    },
    isDurationTypeSeconds() {
      return (
        this.$store.state.alerts.mediumPriorityAlert.schedule.durationType ===
        'seconds'
      )
    },
    getDurationInSeconds() {
      return this.$store.state.alerts.mediumPriorityAlert.schedule.alertDuration
    },
    getAlertTitle() {
      return this.$store.state.alerts.mediumPriorityAlert.title
    },
    getAlertDetails() {
      return this.$store.state.alerts.mediumPriorityAlert.details
    },
    isAlertButtonEnabled() {
      return this.$store.state.alerts.mediumPriorityAlert.button?.isEnabled
    },
    getAlertButtonLabel() {
      return this.$store.state.alerts.mediumPriorityAlert.button?.label
    },
    getAlertButtonURL() {
      return this.$store.state.alerts.mediumPriorityAlert.button?.url
    }
  },
  mounted() {
    if (this.isDurationTypeSeconds) {
      this.setTimeoutTimerId = setTimeout(() => {
        this.handleCloseClicked()
      }, this.getDurationInSeconds * 1000)
    }
  },
  methods: {
    sanitizeFontStyles(html) {
      if (!html) return ''
      if (this.$store.getters.isFontFamilyChatInterfaceOverrideEnabled) {
        html = html.replace(/font-family:[^;"]*;?/gi, '')
      }
      if (this.$store.getters.isFontSizeChatInterfaceOverrideEnabled) {
        html = html.replace(/font-size:[^;"]*;?/gi, '')
      }
      return html
    },
    handleAlertButtonClicked() {
      window.open(this.getAlertButtonURL, 'noopener', 'noreferrer')
    },
    handleCloseClicked() {
      this.$store.dispatch('updateMediumPriorityAlertState', {})
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/css/theme.scss';
@import '@/styles/css/commonStyles.scss';

.medium-priority-alert-wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2147483647;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.3);
  .medium-priority-alert-container {
    @include border-radius(var(--radius-chat-inner-component));
    background: #fff;
    padding: 16px;
    width: 100%;
    max-width: 606px;
    box-sizing: border-box;
    height: auto;
    box-shadow:
      0px 3.2px 7.2px 0px rgba(0, 0, 0, 0.13),
      0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.4);
    background-color: #fef5ec;
    .alert-content {
      .alert-header {
        display: flex;
        align-items: center;
        gap: 8px;
        .header-text {
          line-height: 22px;
          font-weight: 500;
        }
      }
      .details {
        margin-top: 16px;
        margin-bottom: 24px;
        margin-left: 32px;
        font-size: inherit;
        font-weight: 400;
        line-height: 18px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        a {
          text-decoration: underline;
          color: #1e6ff1;
        }
      }
      .card-button {
        @include border-radius(var(--radius-chat-inner-component));
        cursor: pointer;
        padding: 10px 24px 10px 24px;
        font-size: inherit;
        font-weight: 600;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000000;
        color: #ffffff;
        &:focus-visible {
          outline: $tab-focused-outline;
        }
      }
      .close-btn {
        cursor: pointer;
        padding: 10px 24px 10px 24px;
        font-size: inherit;
        font-weight: 400;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:focus-visible {
          outline: $tab-focused-outline;
        }
      }
    }
    &.medium-priority-alert-container-compact {
      position: absolute;
      bottom: 0;
      padding: 24px;
    }
  }
}
</style>
